// extracted by mini-css-extract-plugin
export default {"root":"ayQCXi8GgndF73ocdJiy","item":"SG4tTptOJhtEei0HIQAm","icon":"G88GEuUmatzyAOrDR5UG","description":"Wz5QsQY7Y2hmsD0wO6Fg","cta":"oH38i0pxRIcA0Mi8WQCA"};